export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11544.65eb7bd7.jpg";